import { KcConfig } from './kc-config';
import { DeepLinkConfig } from './deep-link-config';

export class ModuleConfig {
  keycloakConfig: KcConfig;
  deepLinksConfig: DeepLinkConfig;
}
